import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";

import { ItemListRequest, ItemListResponse } from "helpers/interfaces";
import { Redirect, useHistory, useLocation } from "react-router";

interface ICustomersContext {
    recordCount: number
    search: ISearch
    customers: ICustomer[]
    isLoading: boolean
    
    updateSearch: (newSearch: ISearch) => void
    doSearch: (newSearch: ISearch) => void
    changePage: (page: number) => void
    deleteCustomer: (CustomerId: string) => Promise<void>
}

export interface ICustomer {
    id: string
    email: string
    name: string
    companyName: string
    m3Id: string
    existOnCognito: boolean
}

export let customersContext = React.createContext<ICustomersContext>({} as ICustomersContext);

let { Provider } = customersContext;

interface ISearch extends ItemListRequest {
    email: string
    company: string
    m3Id: string
}

let CustomersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let { enqueueSnackbar } = useSnackbar()
    let location = useLocation();
    let history = useHistory();

    let [recordCount, setRecordCount] = useState<number>(0);
    let [search, setSearch] = useState<ISearch>({
        pageNr: 0,
        pageSize: 20,
        email: "",
        company: "",
        m3Id: ''
    });

    
    let [isLoading, setLoading] = useState(true);
    let [customers, setCustomers] = useState<ICustomer[]>([]);


    useEffect(() => {
        if (location.state)
            processState(location.state);

    }, [location.state])


    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        let request = { ...search }

        if (state.search) {
            request = {
                ...request,
                ...state.search
            }
        }

        setSearch(request)
        searchCustomers(request);
    }

    let doSearch = (newSearch: ISearch) => {
        let request = {
            ...newSearch,
            pageNr: 0
        }

        history.push(location.pathname, { search: request });
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let searchCustomers = async (searchRequest: ISearch) => {
        try {
            setLoading(true);

            let response = await axios.post<ItemListResponse<ICustomer>>('/api/User/SearchCustomers', searchRequest);
            setCustomers(response.data.items);
            setRecordCount(response.data.recordCount);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let changePage = (page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        history.push(location.pathname, { search: request });
    }

    let deleteCustomer = async (customerId: string) => {
        if (window.confirm("Are you sure that you want to remove this customer?")) {
            try {
                await axios.delete(`/api/User/DeleteUser/${customerId}`);
                setCustomers(customers.filter(Customer => Customer.id !== customerId));
                enqueueSnackbar("Customer deleted", { variant: 'success' });

            } catch (err) { }
        }
    }

    


    return (
        <Provider value={{
            recordCount,
            search,
            customers,
            isLoading,
            
            changePage,
            doSearch,
            updateSearch,
            deleteCustomer
        }}>
            {children}
        </Provider>
    );
};

export default CustomersProvider